import React from 'react';
import { Rectangle } from '../Rectangle/Rectangle';
import style from './CodeArea.scss';
import { HighlightDisplay } from '../HighlightDisplay';
import syntaxDisplayTheme from '../../TypeDetails/OperationDetails/SyntaxDisplay/JSFunctionDisplay/syntaxDisplayTheme';
import { Text } from '../Text';
import { CopyCode } from '../CopyCode';

export const CodeArea = (props) => {
  const languageWithLowerCase = props.language && props.language.toLowerCase();
  return (
    <Rectangle className={style.displayMarkDownCodeContainer}>
      <span className="notranslate">
        <HighlightDisplay
          {...props}
          language={languageWithLowerCase}
          theme={syntaxDisplayTheme}
        />
      </span>
      <Text
        tagName="span"
        size="tiny"
        weight="thin"
        className={`
        ${style.language} ${style.copyCodeContainer}`}
        dataHook="language-text"
      >
        {props.language ? `${props.language}  |  ` : ''}
        <CopyCode code={props.value} />
      </Text>
    </Rectangle>
  );
};
